// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","354":"41155975","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"c1d61290b9dab19c4cd6","245":"ef3c4959ff8397dc7574","354":"d8380adc1459b2b72267","452":"82dbc7d1e4772099680b","453":"4129e87606ccf56cd0b2"}[chunkId] + ".js";
};